import { MapSchema } from "./type";

export function mapSchema(props: Omit<MapSchema, "type">): MapSchema {
  return props;
}
